/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_LegalInputs */

const cs_templates_use_legal = /** @type {(inputs: Templates_Use_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_templates_use_legal = /** @type {(inputs: Templates_Use_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

/**
* | output |
* | --- |
* | "Use" |
*
* @param {Templates_Use_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_legal = /** @type {((inputs?: Templates_Use_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_legal(inputs)
	return cs_templates_use_legal(inputs)
});